import FinanceAdapter from './base';

export default class TillSession extends FinanceAdapter {
  modelNamePlural = 'tillSessions';
}
